export { KIRALAMA_AKTIF_DURUMLAR } from '@emanetx/shared-types';
function sorguDizgesi(sorgu) {
    const params = new URLSearchParams();
    if (sorgu.sayfa)
        params.set('sayfa', String(sorgu.sayfa));
    if (sorgu.boyut)
        params.set('boyut', String(sorgu.boyut));
    if (sorgu.arama)
        params.set('arama', sorgu.arama);
    if (sorgu.durum)
        params.set('durum', sorgu.durum);
    if (sorgu.aktifMi !== undefined)
        params.set('aktifMi', String(sorgu.aktifMi));
    if (sorgu.noktaId)
        params.set('noktaId', sorgu.noktaId);
    if (sorgu.dolapId)
        params.set('dolapId', sorgu.dolapId);
    if (sorgu.baslangicTen)
        params.set('baslangicTen', sorgu.baslangicTen);
    if (sorgu.baslangicAKadar)
        params.set('baslangicAKadar', sorgu.baslangicAKadar);
    const s = params.toString();
    return s ? `?${s}` : '';
}
export async function kiralamalariListele(istemci, sorgu = {}) {
    return istemci.istek(`/kiralamalar${sorguDizgesi(sorgu)}`);
}
export async function kiralamaGetir(istemci, id) {
    return istemci.istek(`/kiralamalar/${id}`);
}
export async function kiralamaZorlaSonlandir(istemci, id, giris) {
    return istemci.istek(`/kiralamalar/${id}/zorla-sonlandir`, {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function kiralamaManuelAc(istemci, id, giris) {
    return istemci.istek(`/kiralamalar/${id}/manuel-ac`, {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function kiralamaIadeBasla(istemci, id, giris) {
    return istemci.istek(`/kiralamalar/${id}/iade-basla`, {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
//# sourceMappingURL=kiralamalar.js.map